import React from 'react';

import "./styles.css";

export default function Abas(props) {
  const { tabs, value, handleChange } = props;
  const obterValorAba = (tab, index) => tab?.id ?? Number(index) + 3;

  const handleKeyDown = (event, index) => {
    if (!tabs.length) return;

    let proximoIndice = index;

    if (event.key === "ArrowRight") {
      proximoIndice = (index + 1) % tabs.length;
    } else if (event.key === "ArrowLeft") {
      proximoIndice = (index - 1 + tabs.length) % tabs.length;
    } else if (event.key === "Home") {
      proximoIndice = 0;
    } else if (event.key === "End") {
      proximoIndice = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    const proximoValor = obterValorAba(tabs[proximoIndice], proximoIndice);
    handleChange(proximoValor);

    window.requestAnimationFrame(() => {
      document
        .getElementById(`aba-faturamento-${proximoValor}`)
        ?.focus();
    });
  };

  return (
    <div
      role="tablist"
      aria-label="Seções do faturamento"
      className="abas-faturamento"
    >
      {tabs.map((t, i) => {
        const tabValue = obterValorAba(t, i);
        const tabLabel = t?.label ?? t;
        const testId = t?.id ? `aba-faturamento-${t.id}` : `aba-faturamento-${i}`;
        const ativo = Number(value) === Number(tabValue);

        return (
        <button
          key={tabValue}
          type="button"
          id={`aba-faturamento-${tabValue}`}
          data-testid={testId}
          role="tab"
          aria-selected={ativo}
          tabIndex={ativo ? 0 : -1}
          className={ativo ? "aba-faturamento-on" : "aba-faturamento"}
          onClick={() => handleChange(tabValue)}
          onKeyDown={(event) => handleKeyDown(event, i)}
        >
          {tabLabel}
        </button>
        );
      })}
    </div>
  )
}
